<div class="ctnr d-flex justify-content-center align-items-center p-3">
    <div class="alert-box alert alert-success p-4" role="alert">
        <h4 class="alert-heading fw-bold">Successful Logout</h4>
        <p>You have Successfully logged out, to login press the button below.</p>
        <div class="d-flex justify-content-end">
          <button class="btn btn-success" (click)="navigateToLogin()">Login</button>
        </div>
    </div>
  </div>